<h3 class="mb-0 p-3 align-self-center" data-cy="pageTitle">Support</h3>
<div class="m-4 mt-2" style="max-width: 38rem">
  <div class="d-flex align-items-center gap-3 mb-3">
    <i class="fa-solid fa-phone" style="font-size: var(--fs-4xl)"></i>
    <a href="tel:+1-{{ phone() }}">{{ phone() }}</a>
  </div>
  <div class="d-flex align-items-center gap-3">
    <i class="fa-solid fa-envelope" style="font-size: var(--fs-4xl)"></i>
    <a class="pb-1" href="mailto:{{ email() }}">{{ email() }}</a>
  </div>
</div>
